import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router'
import { IssueEntity } from 'types/IssueEntity'
import { WarrantName } from '../../../components/entities/WarrantName'
import { FactsTableRow } from '../../components/FactsTable'

export function WarrantsRow({ issue }: { issue: IssueEntity }) {
    const { t } = useTranslation()

    if (issue.warrants && issue.warrants.length > 0) {
        const warrantElements: ReactNode[] = []
        issue.warrants.forEach((warrant) => {
            warrantElements.push(
                <Typography key={warrant.id}>
                    <Link to={`/warrants/${warrant.id}`}>
                        <WarrantName warrant={warrant} />
                    </Link>
                    <br />
                </Typography>,
            )
        })
        return <FactsTableRow label={t('pages.issues.terms.warrants')}>{warrantElements}</FactsTableRow>
    } else {
        return (
            <FactsTableRow label={t('pages.issues.terms.warrants')}>
                <i>{t('pages.issues.terms.warrantsNone')}</i>
            </FactsTableRow>
        )
    }
}
